import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
import { exportFile_Customer } from "../analyzeSlice";
import { catchElement, elementToBase64 } from "../analyzeUtils";

export default function DataExport() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    duration,
    selectedCountry,
    selectedCountryID,
    selectedCustomerName,
    selectedCustomerID,
    selectedSkuPgName,
    selectedScenarioName,
    selectedScenarioID,
    customerTD,
  } = state;

  async function exportDataAsFile(isPdf) {
    const multiLineChartElement = catchElement(".multiLineChart");
    const multiLineChartBase64 = await elementToBase64(multiLineChartElement);
    const chartImage = [multiLineChartBase64];
    const postData = {
      isPdf,
      AnalyzeTitle: `Analyze: ${selectedScenarioName} Customer`,
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      CustomerID: selectedCustomerID,
      CustomerName: selectedCustomerName,
      ProductName: selectedSkuPgName,
      ScenarioID: selectedScenarioID,
      ScenarioName: selectedScenarioName,
      Duration: duration,
      listAnalyseData: customerTD,
      chartImage: chartImage,
    };
    dispatch(exportFile_Customer(postData));
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <IconButton onClick={(e) => exportDataAsFile(false)}>
        <GridOnIcon sx={{ color: "green.main" }} />
      </IconButton>
      <IconButton onClick={(e) => exportDataAsFile(true)}>
        <PictureAsPdfIcon sx={{ color: "red.main" }} />
      </IconButton>
    </Box>
  );
}
